import type { ListCookingSessionsParams } from "@/types/cooking-session";

/** One station or one chef a lane is narrowed to, or null for everyone (YC-36). */
export type AssigneeFilter = { type: "station" | "chef"; id: number } | null;

/** The list query params for a filter. */
export function assigneeFilterParams(
  filter: AssigneeFilter,
): Partial<Pick<ListCookingSessionsParams, "stationId" | "chefId">> {
  if (!filter) return {};
  return filter.type === "station" ? { stationId: filter.id } : { chefId: filter.id };
}
